import { WebSocketConnectionOption } from 'types';

export const createWebSocketConnection = ({
  entity,
  entityId,
  token,
  clientId,
  onClose,
  onError,
  onMessage,
  onOpen
}: WebSocketConnectionOption) => {
  const { REACT_APP_WEBSOCKET_URL } = process.env;
  const websocket = new WebSocket(
    `${REACT_APP_WEBSOCKET_URL}?entity=${entity}&entityId=${entityId}&clientId=${clientId}&token=${token}`
  );

  if (onClose) {
    websocket.addEventListener('close', onClose);
  }

  if (onError) {
    websocket.addEventListener('error', onError);
  }

  if (onMessage) {
    websocket.addEventListener('message', onMessage);
  }

  if (onOpen) {
    websocket.addEventListener('open', onOpen);
  }

  return websocket;
};
